import { render } from "./AutomationBuilder.vue?vue&type=template&id=5c6974b8&scoped=true"
import script from "./AutomationBuilder.vue?vue&type=script&lang=js"
export * from "./AutomationBuilder.vue?vue&type=script&lang=js"

import "./AutomationBuilder.vue?vue&type=style&index=0&id=5c6974b8&lang=scss"
import "./AutomationBuilder.vue?vue&type=style&index=1&id=5c6974b8&lang=scss"
import "./AutomationBuilder.vue?vue&type=style&index=2&id=5c6974b8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6974b8"]])

export default __exports__